module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.iter-step.js
// module id = 1627
// module chunks = 0